<template>
  <div class="smaller-container-wrapper full-height no-progress-bar">
    <h2 class="pt-3 pt-sm-4 mb-3">{{ $t('message.buildAndPrice.contactDealer.contactForm.heading') }}</h2>
    <p class="mb-1 mb-md-3 mt-0 mt-md-3">{{ $t('message.buildAndPrice.contactDealer.contactForm.subHeading') }}</p>
    <ContactForm ref="contactForm" @contactFormSuccessfullySubmitted="createLead"></ContactForm>
    <div class="push-down-desktop">
      <mobialis-button type="submit" class="mt-5 mb-3" @click="submit()" data-cy="continue">{{
        $t('message.buildAndPrice.contactDealer.contactForm.btnText')
      }}</mobialis-button>
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/shared/ContactForm.vue';

export default {
  name: 'ContactDealerForm',
  components: {
    ContactForm,
  },
  methods: {
    submit() {
      this.$refs.contactForm.submitContactForm();
    },
    async createLead() {
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/createLead');
        this.$router.push({ path: this.getNextRoutePath() });
        this.$store.commit('SET_LOADING', false);
      } catch (err) {
        this.$log('Error in build and price contact dealer update lead', err);
        this.$router.push('error');
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
